import { render, staticRenderFns } from "./BillDocuments.vue?vue&type=template&id=7d056954&scoped=true"
import script from "./BillDocuments.vue?vue&type=script&lang=js"
export * from "./BillDocuments.vue?vue&type=script&lang=js"
import style0 from "./BillDocuments.vue?vue&type=style&index=0&id=7d056954&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d056954",
  null
  
)

export default component.exports